<template>
    <!-- Header -->
    <div class="header">

        <!-- Logo -->
        <div class="header-left active">
            <router-link to="/dashboard" class="logo logo-normal" style="width: inherit;">
                <img src="@/assets/img/nedam_mouhassib.png" alt="">
            </router-link>
            <router-link to="/dashboard" class="logo logo-white" style="width: inherit;">
                <img src="@/assets/img/nedam_mouhassib.png" alt="">
            </router-link>
            <router-link to="/dashboard" class="logo_small" style="width: inherit;">
                <img src="@/assets/img/nedam_icon2@4x.png" alt="">
            </router-link>
            <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
                <vue-feather type="chevrons-left"></vue-feather>
            </a>
        </div>
        <!-- /Logo -->

        <a id="mobile_btn" class="mobile_btn" href="javascript:void(0);" @click="toggleSidebar1">
            <span class="bar-icon">
                <span></span>
                <span></span>
                <span></span>
            </span>
        </a>

                <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Search -->
      <li class="nav-item nav-searchinputs">
        <div class="top-nav-search">
          <a href="javascript:void(0);" class="responsive-search">
            <i class="fa fa-search"></i>
          </a>
        </div>
      </li>
      <!-- /Search -->

      <li class="nav-item dropdown has-arrow main-drop">
        <a
          href="javascript:void(0);"
          class="dropdown-toggle nav-link userset"
          data-bs-toggle="dropdown"
        >
          <span class="user-info">
            <span class="user-letter">
              <img
                src="@/assets/img/user.png"
                alt=""
                class="img-fluid"
              />
            </span>
            <span class="user-detail">
              <span class="user-name">{{ userName }}</span>
              <span class="user-role">{{ userRoleDisplay }}</span>
            </span>
          </span>
        </a>
        <div class="dropdown-menu menu-drop-user">
          <div class="profilename">
            <div class="profileset">
              <span class="user-img"
                ><img src="@/assets/img/user.png" alt="" />
                <span class="status online"></span
              ></span>
              <div class="profilesets">
                <h6 class="user-name">{{ userName }}</h6>
                <h5 class="user-role">{{ userRoleDisplay }}</h5>
              </div>
            </div>
            <hr class="m-0" />
            <router-link class="dropdown-item" to="/profile">
              <vue-feather class="me-2" type="user"></vue-feather> Mon
              Profile</router-link
            >
            <router-link v-if="isAdmin" class="dropdown-item" to="/settings"
              ><vue-feather class="me-2" type="settings"></vue-feather
              >Paramètres</router-link
            >
            <hr class="m-0" />
            <router-link class="dropdown-item logout pb-0" to="/logout"
              ><img
                src="@/assets/img/icons/log-out.svg"
                class="me-2"
                alt="img"
              />Logout</router-link
            >
          </div>
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:void(0);"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa fa-ellipsis-v"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/profile"
          >Mon Profile</router-link
        >
        <router-link v-if="isAdmin" class="dropdown-item" to="/settings">Paramètres</router-link>
        <router-link class="dropdown-item" to="/logout">Logout</router-link>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <side-settings></side-settings>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      userName: '',
      userRole: null,
      isAdmin: false
    };
  },
  computed: {
    userRoleDisplay() {
      return this.isAdmin ? 'Admin' : 'User';
    }
  },
  mounted() {
    this.getUserFromLocalStorage();
    this.fetchAndUpdateUserProfile();
    this.initMouseoverListener();
  },
  methods: {
    getUserFromLocalStorage() {
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const userData = JSON.parse(user);
          this.userName = userData.name || '';
          this.userRole = userData.role;
          this.isAdmin = userData.role === 'admin';
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error);
        }
      }
    },
    async fetchAndUpdateUserProfile() {
      try {
        const response = await axios.get('/profile');
        const user = response.data;

        this.userName = user?.name || '';
        this.isAdmin = user?.is_admin || false;
        this.userRole = this.isAdmin ? 'admin' : 'user';

        // Update localStorage with fresh data
        const userData = {
          name: this.userName,
          role: this.userRole,
          is_admin: this.isAdmin
        };
        localStorage.setItem('user', JSON.stringify(userData));

        this.initMouseoverListener();
      } catch (error) {
        console.error("Erreur lors de la récupération du profil :", error);
        // Fall back to localStorage data if API call fails
        this.getUserFromLocalStorage();
      }
    },
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    initMouseoverListener() {
      document.addEventListener("mouseover", this.handleMouseover);
    },
    handleMouseover(e) {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        this.isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          this.slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          this.slideUpSubmenu();
        }

        e.preventDefault();
      }
    },
    isElementVisible(element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    },
    slideDownSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "block";
        }
      }
    },
    slideUpSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "none";
        }
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("mouseover", this.handleMouseover);
  },
};
</script>